module.exports = __webpack_public_path__ + "static/language-1-mobile-25cb556fb05bd434e797212e3a6a49a7.jpg";